<template>
    <v-dialog width="550px" v-model="viewMenu">
        <v-card>
            <v-card-title>neue Balkenkopfreparatur</v-card-title>
            <v-card-text>
                <v-text-field label="Spannweite" type="number" min="1" v-model.number="Spannweite" :suffix="LängenEinheit.name" required></v-text-field>
                <v-text-field label="Schadlänge" type="number" :max="Spannweite" v-model.number="Schadlänge" :suffix="LängenEinheit.name" required></v-text-field>
                <v-text-field label="Blattlänge" type="number" min="0.1" max="4" v-model.number="Blattlänge" :suffix="LängenEinheit.name" required></v-text-field>
                <v-text-field label="VM Randabstand zum Hirnholz" type="number" min="0.1" max="4" v-model.number="Randabstand" :suffix="LängenEinheit.name" required></v-text-field>
                <v-text-field label="Belastung" type="number" v-model.number="Belastung" :suffix="KraftEinheit.name + '/' + LängenEinheit.name" required></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn small @click="apply()" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" >Abbrechen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data(){
        return{
            Spannweite: 5.3,
            Schadlänge: 1.5,
            Blattlänge: 0.8,
            Belastung: 1.8,
            Randabstand: 0.1,
            LängenEinheit: this.$store.state.LängenEinheiten.m,
            KraftEinheit: this.$store.state.KraftEinheiten.kN,
        }
    },
    computed: {
        viewMenu: {
            get() { return this.$store.getters.vNewBalkenkopfRepMenu },   
            set(value) { this.$store.commit('setvNewBalkenkopfRepMenu', value)} 
        },
    },
    methods: {
        apply(){
            // Hier sollten noch Überprüfungen auf sinnvolle Eingaben gemacht werden.
            let SystemData = { 
                    Spannweite: this.Spannweite*this.LängenEinheit.value,
                    Schadlänge: this.Schadlänge*this.LängenEinheit.value,
                    Blattlänge: this.Blattlänge*this.LängenEinheit.value,
                    Randabstand: this.Randabstand*this.LängenEinheit.value,
                    Belastung: this.Belastung*this.KraftEinheit.value/this.LängenEinheit.value,
                }
            this.$store.dispatch('newBalkenkopfRep', SystemData)
            this.viewMenu = false
        },
        cancel(){
            this.viewMenu = false
        },
    },
}
</script>